import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEECECoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Electronics and Communication Engineering",
    shortName: "B.E. ECE",
    duration: "4 years",
    description: "Engineering program focused on electronic systems, communication technologies, and signal processing",
    overview: "Bachelor of Engineering in Electronics and Communication Engineering (B.E. ECE) is a 4-year undergraduate program that deals with electronic devices, circuits, communication equipment, and systems. This course covers analog and digital electronics, microprocessors, signal processing, wireless communication, and embedded systems, preparing students for careers in telecommunications, electronics design, and emerging technologies.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in electronics and communication systems"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Basic Electronics Engineering",
          "Programming in C"
        ]
      },
      {
        year: 2,
        subjects: [
          "Electronic Devices and Circuits",
          "Digital Electronics",
          "Network Theory",
          "Electromagnetic Fields",
          "Signals and Systems",
          "Electronic Measurements"
        ]
      },
      {
        year: 3,
        subjects: [
          "Analog and Digital Communication",
          "Microprocessors and Microcontrollers",
          "Control Systems",
          "VLSI Design",
          "Antenna and Wave Propagation",
          "DSP and Digital Filters"
        ]
      },
      {
        year: 4,
        subjects: [
          "Mobile and Satellite Communication",
          "Optical Communication",
          "Embedded Systems",
          "RF and Microwave Engineering",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Electronics Engineer",
        "Communication Engineer",
        "RF Engineer",
        "VLSI Design Engineer",
        "Embedded Systems Engineer",
        "Signal Processing Engineer",
        "Network Engineer",
        "Test Engineer",
        "R&D Engineer",
        "Technical Consultant"
      ],
      industries: [
        "Telecommunications",
        "Electronics Manufacturing",
        "Semiconductor Industry",
        "Defense and Aerospace",
        "Broadcasting and Media",
        "Mobile Network Operators",
        "IT and Software Services",
        "Research and Development",
        "Consumer Electronics",
        "IoT and Embedded Systems"
      ],
      averageSalary: "₹5-9 LPA (Fresher), ₹15-35 LPA (Experienced)",
      topRecruiters: [
        "TCS, Infosys, Wipro",
        "Qualcomm, Intel, Broadcom",
        "ISRO, DRDO, HAL",
        "Airtel, Jio, BSNL",
        "Samsung, LG Electronics",
        "Bosch, Continental"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "SSN College of Engineering",
        location: "Chennai",
        fees: "₹4,20,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Thiagarajar College of Engineering",
        location: "Madurai",
        fees: "₹3,20,000",
        ranking: "NIRF Ranking: 78"
      }
    ],

    skills: [
      "Circuit Design and Analysis",
      "MATLAB/Simulink",
      "VLSI Design Tools",
      "Embedded C Programming",
      "RF Circuit Design",
      "Signal Processing",
      "Communication Protocols",
      "PCB Design",
      "Microcontroller Programming",
      "Network Protocols"
    ],

    futureScope: "Excellent prospects with 5G technology, IoT expansion, semiconductor growth, AI integration in electronics, and India's semiconductor mission creating massive opportunities.",

    faqs: [
      {
        question: "What's the difference between ECE and EEE?",
        answer: "ECE focuses on electronics, communication systems, and signal processing, while EEE emphasizes power systems, electrical machines, and energy applications."
      },
      {
        question: "Can ECE graduates work in software companies?",
        answer: "Yes, many ECE graduates work in software roles, especially in embedded systems, telecommunications software, signal processing applications, and IoT development."
      },
      {
        question: "What are the emerging fields in ECE?",
        answer: "5G/6G communications, IoT, AI chips, autonomous vehicles, smart cities, medical electronics, and quantum communication are rapidly growing areas."
      },
      {
        question: "Is VLSI design a good career option?",
        answer: "Yes, VLSI design offers excellent career prospects with high salaries in semiconductor companies, especially with India's semiconductor manufacturing initiatives."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEECECoursePage;
